import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Thu Aug 09 2018
 * @author VBr
 * @author LZe
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { jsonConversions, PriceZoneConverter } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
import { CONSTANTS } from '../../../constants';
import api from '../../api';
import logger from '../../logger';
import { CRUTransportLayer } from '../CRUTransportLayer';
export var PriceZoneLayer =
/*#__PURE__*/
function (_CRUTransportLayer) {
  _inherits(PriceZoneLayer, _CRUTransportLayer);

  function PriceZoneLayer() {
    _classCallCheck(this, PriceZoneLayer);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceZoneLayer).call(this, CONSTANTS.API.ENDPOINTS.ZONES));
  }

  _createClass(PriceZoneLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.converter;
    }
  }, {
    key: "createWithProgress",
    value: function createWithProgress(priceZone) {
      var document = this.getConverter().toDocument(priceZone, jsonConversions);
      var createPromise = api("".concat(this.baseUri)).post(priceZone.numericId ? Object.assign(Object.assign({}, document), {
        numericId: priceZone.numericId
      }) : document, {
        responseType: 'json'
      }).then(function (response) {
        return response.data.progress.id;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return createPromise;
    }
    /**
     * Archives specified price zone
     * @returns updated price zone
     */

  }, {
    key: "archive",
    value: function archive(zoneId) {
      var archivePromise = api(CONSTANTS.API.ENDPOINTS.ARCHIVE_ZONE(zoneId)).post({
        responseType: 'json'
      }).then(function (response) {
        return Promise.resolve();
      }).catch(function (error) {
        return Promise.reject(error);
      });
      return archivePromise;
    }
    /** @returns National price zone */

  }, {
    key: "getNational",
    value: function getNational() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _ref, data;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return api(CONSTANTS.API.ENDPOINTS.NATIONAL_ZONE).get();

              case 3:
                _ref = _context.sent;
                data = _ref.data;
                return _context.abrupt("return", this.converter.toObject(data, jsonConversions));

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", Promise.reject(_context.t0));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 8]]);
      }));
    }
    /**
     * Changes competitors in price zones and returns updated array of price zones
     * @param priceZoneIds
     * @param competitorsSiteIds
     */

  }, {
    key: "changeCompetitors",
    value: function changeCompetitors(priceZoneIds, competitorSiteIds) {
      var _this = this;

      var changeCompetitorsPromise = api(CONSTANTS.API.ENDPOINTS.ZONES_CHANGE_COMPETITORS).post({
        ids: priceZoneIds,
        competitorSiteIds: competitorSiteIds
      }, {
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this.getConverter().toObject(item, jsonConversions));
        });
        return arr;
      }).catch(function (error) {
        return Promise.reject(error);
      });
      return changeCompetitorsPromise;
    }
  }]);

  return PriceZoneLayer;
}(CRUTransportLayer);

__decorate([Inject, __metadata("design:type", PriceZoneConverter)], PriceZoneLayer.prototype, "converter", void 0);